const _ = require('lodash')

function mapKeyValues(object, valueModifier = null, keyModifier = null) {
  return Object.keys(object).reduce(
    (previous, key) => {
      const value = object[key]
      const newValue = valueModifier ? valueModifier(value, key, object) : value
      const newKey = keyModifier ? keyModifier(key, value, object) : key
      previous[newKey] = newValue
      return previous
    }, {});
}



module.exports = {
  mapKeyValues
}

